export const menuTheme = {
  submenu: {
    label: {
      padding: 'var(--three-fourth-rem) var(--rem)',
    },
  },
  item: {
    padding: 'var(--three-fourth-rem) var(--rem)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-white)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--transparent)',
      },
      item: {
        icon: {
          color: 'var(--p-primary-500)',
          focusColor: 'var(--p-primary-500)',
        },
        color: 'var(--p-primary-500)',
        focusColor: 'var(--p-primary-500)',
      },
      submenu: {
        label: {
          background: 'var(--p-white)',
          color: 'var(--text-color)',
        },
      },
      separator: {
        borderColor: 'var(--text-color-secondary)',
      },
    },
    dark: {
      root: {
        background: 'var(--ground-background)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--transparent)',
      },
      item: {
        icon: {
          color: 'var(--p-primary-500)',
          focusColor: 'var(--p-primary-500)',
        },
        color: 'var(--p-primary-500)',
        focusColor: 'var(--p-primary-500)',
      },
      submenu: {
        label: {
          background: 'var(--p-white)',
          color: 'var(--text-color)',
        },
      },
      separator: {
        borderColor: 'var(--text-color-secondary)',
      },
    },
  },
  root: {
    borderRadius: 'var(--border-radius)',
  },
};
